import type { FC } from 'react';

import { AppleAppStoreLogo } from '@/components/download-for-mobile/apple-app-store-logo';
import { BaseBlock } from '@/components/base-block';
import { BlockHeader } from '@/components/block-header';
import { GooglePlayLogo } from '@/components/download-for-mobile/google-play-logo';
import { Link } from '@/components/link';
import { URLS } from '@/lib/constants';
import { WidgetProps } from '@/components/widget-block';

const DownloadForMobile: FC<WidgetProps> = ({ anchor = null }) => (
  <BaseBlock className="rich-text" width="Narrow" anchor={anchor} hasContentPadding={false}>
    <div className="mobile-apps-container">
      <BlockHeader title="Download for mobile" />
      <p>
        You can download the <strong>RACT Fuel Saver</strong> app via the Apple App or Google Play stores.
      </p>

      <div id="store-buttons" className="store-buttons">
        <Link href={URLS.RACT_APPLE_APP_STORE} title="RACT Apple App Store" target="blank">
          <AppleAppStoreLogo />
        </Link>
        <Link href={URLS.RACT_GOOGLE_PLAY_STORE} title="RACT Google Play Store" target="blank">
          <GooglePlayLogo />
        </Link>
      </div>
    </div>
  </BaseBlock>
);

export { DownloadForMobile };
